'use client';

import Link from 'next/link';

export default function AuthFooter() {
  return (
    <footer className="">
      <div className="mx-auto flex max-w-md flex-col items-center gap-4 text-center text-sm text-muted-foreground">
        <p>
          ¿Necesitas ayuda?{' '}
          <a href="mailto:hola@reparoly.com" className="font-medium text-primary hover:underline">
            Escríbenos
          </a>
        </p>
        <p>
          Al continuar aceptas nuestros{' '}
          <Link href="/terms" className="font-medium text-primary hover:underline">
            términos
          </Link>{' '}
          y{' '}
          <Link href="/privacy" className="font-medium text-primary hover:underline">
            política de privacidad
          </Link>
          .
        </p>
      </div>
    </footer>
  );
}
